export const Grupos_reporte = 240
export const Tipos_reporte = 56
// Estados de solicitudes de validacion (espejo de components/validaciones/Helpers.js -> ESTADOS)
export const ESTADOS_VALIDACIONES = 74
